import { MainComponent } from './main/main.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'accueil', pathMatch: 'full' },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'formations/formations-en-apprentissage/:type',
        loadChildren: () =>
          import('./training-list/training-list.module').then(
            (m) => m.TrainingListModule
          ),
      },
      {
        path: 'accueil',
        loadChildren: () =>
          import('./homepage/homepage.module').then((m) => m.HomepageModule),
      },
      {
        path: 'apprenti',
        loadChildren: () =>
          import('./apprentice-page/apprentice-page.module').then(
            (m) => m.ApprenticePageModule
          ),
      },
      {
        path: 'employeur',
        loadChildren: () =>
          import('./employer-page/employer-page.module').then(
            (m) => m.EmployerPageModule
          ),
      },
      {
        path: 'employeur/informations-maitre-apprentissage',
        loadChildren: () =>
          import(
            './employer-informations-pages/learning-master-informations/learning-master-informations.module'
          ).then((m) => m.LearningMasterInformationsModule),
      },
      {
        path: 'employeur/frais-offre-de-formation',
        loadChildren: () =>
          import(
            './employer-informations-pages/supply-of-training-costs/supply-of-training-costs.module'
          ).then((m) => m.SupplyOfTrainingCostsComponentModule),
      },
      {
        path: 'employeur/cfa-support',
        loadChildren: () =>
          import(
            './employer-informations-pages/cfa-support/cfa-support.module'
          ).then((m) => m.CfaSupportModule),
      },
      {
        path: 'employeur/obligations-informations',
        loadChildren: () =>
          import(
            './employer-informations-pages/employer-obligations-informations/employer-obligations-informations.module'
          ).then((m) => m.EmployerObligationsInformationsModule),
      },
      {
        path: 'employeur/informations-exoneration-de-charges',
        loadChildren: () =>
          import(
            './employer-informations-pages/exemption-from-charges-informations/exemption-from-charges-informations.module'
          ).then((m) => m.ExemptionFromChargesInformationsModule),
      },
      {
        path: 'employeur/informations-modalites-financieres',
        loadChildren: () =>
          import(
            './employer-informations-pages/financial-modalities-informations/financial-modalities-informations.module'
          ).then((m) => m.FinancialModalitiesInformationsModule),
      },
      {
        path: 'employeur/aides',
        loadChildren: () =>
          import(
            './employer-informations-pages/help-to-employers-informations/help-to-employers-informations.module'
          ).then((m) => m.HelpToEmployersInformationsModule),
      },
      {
        path: 'employeur/comment-recruter-un-apprenti',
        loadChildren: () =>
          import(
            './employer-informations-pages/how-to-recruit-apprentice-informations/how-to-recruit-apprentice-informations.module'
          ).then((m) => m.HowToRecruitApprenticeInformationsModule),
      },
      {
        path: 'employeur/comment-recruter-un-apprenti-handicape',
        loadChildren: () =>
          import(
            './employer-informations-pages/how-to-recruit-disabled-apprentice-informations/how-to-recruit-disabled-apprentice-informations.module'
          ).then((m) => m.HowToRecruitDisabledApprenticeInformationsModule),
      },
      {
        path: 'ufa',
        loadChildren: () =>
          import('./ufa-page/ufa-page.module').then((m) => m.UfaPageModule),
      },
      {
        path: 'actualites',
        loadChildren: () =>
          import('./news-page/news-page.module').then((m) => m.NewsPageModule),
      },
      {
        path: 'a-propos',
        loadChildren: () =>
          import('./about-page/about-page.module').then(
            (m) => m.AboutPageModule
          ),
      },
      {
        path: 'a-propos/acteur-offre-apprentissage',
        loadChildren: () =>
          import(
            './apprentice-informations-pages/actor-learning-offer/actor-learning-offer.module'
          ).then((m) => m.ActorLearningOfferModule),
      },
      {
        path: 'a-propos/obligations-apprentis',
        loadChildren: () =>
          import(
            './apprentice-informations-pages/apprentice-obligations-informations/apprentice-obligations-informations.module'
          ).then((m) => m.ApprenticeObligationsInformationsModule),
      },
      {
        path: 'a-propos/droits-apprentis',
        loadChildren: () =>
          import(
            './apprentice-informations-pages/apprentice-rights-informations/apprentice-rights-informations.module'
          ).then((m) => m.ApprenticeRightsInformationsModule),
      },
      {
        path: 'a-propos/devenir-apprenti',
        loadChildren: () =>
          import(
            './apprentice-informations-pages/become-apprentice-informations/become-apprentice-informations.module'
          ).then((m) => m.BecomeApprenticeInformationsModule),
      },
      {
        path: 'a-propos/conditions-financieres',
        loadChildren: () =>
          import(
            './apprentice-informations-pages/financial-terms-informations/financial-terms-informations.module'
          ).then((m) => m.FinancialTermsInformationsModule),
      },
      {
        path: 'a-propos/informations-handicap',
        loadChildren: () =>
          import(
            './apprentice-informations-pages/handicap-informations/handicap-informations.module'
          ).then((m) => m.HandicapInformationsModule),
      },
      {
        path: 'a-propos/destinataire-de-l-offre-d-apprentissage',
        loadChildren: () =>
          import(
            './apprentice-informations-pages/learning-offer-receiver-informations/learning-offer-receiver-informations.module'
          ).then((m) => m.LearningOfferReceiverInformationsModule),
      },
      {
        path: 'a-propos/offre-d-apprentissage',
        loadChildren: () =>
          import(
            './apprentice-informations-pages/learning-offer-informations/learning-offer-informations.module'
          ).then((m) => m.LearningOfferInformationsModule),
      },
      {
        path: 'actualite/:id',
        loadChildren: () =>
          import('./actuality-page/actuality-page.module').then(
            (m) => m.ActualityPageModule
          ),
      },
      {
        path: 'validate-email/:token',
        loadChildren: () =>
          import(
            './learning-offer-success-confirmation/learning-offer-success-confirmation.module'
          ).then((m) => m.LearningOfferSuccessConfirmationModule),
      },
      {
        path: 'comment-devenir-ufa',
        loadChildren: () =>
          import(
            './ufa-informations-pages/how-become-ufa/how-become-ufa.module'
          ).then((m) => m.HowBecomeUfaModule),
      },
      {
        path: 'avantages-ufa',
        loadChildren: () =>
          import(
            './ufa-informations-pages/ufa-advantages/ufa-advantages.module'
          ).then((m) => m.UfaAdvantagesModule),
      },
      {
        path: 'description-ufa',
        loadChildren: () =>
          import(
            './ufa-informations-pages/ufa-description/ufa-description.module'
          ).then((m) => m.UfaDescriptionModule),
      },
      {
        path: 'handicap-et-ufa',
        loadChildren: () =>
          import(
            './ufa-informations-pages/ufa-handicap/ufa-handicap.module'
          ).then((m) => m.UfaHandicapModule),
      },
      {
        path: 'obligations-ufa',
        loadChildren: () =>
          import(
            './ufa-informations-pages/ufa-obligations/ufa-obligations.module'
          ).then((m) => m.UfaObligationsModule),
      },
      {
        path: 'qui-devient-ufa',
        loadChildren: () =>
          import(
            './ufa-informations-pages/who-become-ufa/who-become-ufa.module'
          ).then((m) => m.WhoBecomeUfaModule),
      },
      {
        path: 'contrat-ufa',
        loadChildren: () =>
          import(
            './ufa-informations-pages/author-around-contract/author-around-contract.module'
          ).then((m) => m.AuthorAroundContractModule),
      },
      {
        path: 'contact',
        loadChildren: () =>
          import('./contact-page/contact-page.module').then(
            (m) => m.ContactPageModule
          ),
      },
      {
        path: 'offre-d-apprentissage/:id',
        loadChildren: () =>
          import('./learning-offer-page/learning-offer-page.module').then(
            (m) => m.LearningOfferPageModule
          ),
      },
      {
        path: 'inscription',
        loadChildren: () =>
          import('./inscription-page/inscription-page.module').then(
            (m) => m.InscriptionPageModule
          ),
      },
      {
        path: 'offres-d-apprentissage',
        loadChildren: () =>
          import('./learning-offers/learning-offers.module').then(
            (m) => m.LearningOffersModule
          ),
      },
      {
        path: 'creer-une-offre-d-apprentissage',
        loadChildren: () =>
          import('./learning-offer-form/learning-offer-form.module').then(
            (m) => m.LearningOfferFormModule
          ),
      },
      {
        path: 'conditions-generales',
        loadChildren: () =>
          import('./general-conditions/general-conditions.module').then(
            (m) => m.GeneralConditionsModule
          ),
      },
      {
        path: 'politique-de-confidentialite',
        loadChildren: () =>
          import('./privacy-policy/privacy-policy.module').then(
            (m) => m.PrivacyPolicyModule
          ),
      },
      {
        path: 'partenaires',
        loadChildren: () =>
          import('./partners/partners.module').then((m) => m.PartnersModule),
      },
      {
        path: 'chiffres-cles',
        loadChildren: () =>
          import('./cfa-key-number/cfa-key-number.module').then(
            (m) => m.CfaKeyNumberModule
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'accueil',
  } /* LAST PATH !! All unknown url redirect to HomePage */,
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
